import React, { useEffect, useCallback, useState} from 'react';
import {MIDI, SAMPLER, AUDIO, MULTI_FREEZE} from 'constants/track-types.js';
import {WAVEFORM, PIANO_ROLL, INFO} from 'constants/arrangement-modes.js';

export const useToggledWaveform = ({
    isSelectedTrack,
    track,
    sequencerEngine,
    setArrangementBottomMode,
    setShowPianoRoll,
    mode
}) => {
    const toggleWaveform = useCallback(() => {
        let state = sequencerEngine.state;
        let isSampler = track.getTrackType() === SAMPLER ||
            track.getTrackType() === MULTI_FREEZE;
        if (state.sequencer.showPianoRoll) {
            if (state.arrangement.bottomMode === PIANO_ROLL) {
                setArrangementBottomMode(mode ? mode : isSampler ? WAVEFORM : INFO);
                return;
            }
            if (isSelectedTrack) {
                setArrangementBottomMode(
                    mode ? mode : PIANO_ROLL);
            }
        } else {
            setArrangementBottomMode(
                mode ? mode : isSampler ? WAVEFORM : PIANO_ROLL);
        }
        
        if (!isSelectedTrack) {
            return;
        }
        setShowPianoRoll(!sequencerEngine.state.sequencer.showPianoRoll);
    }, [isSelectedTrack, track]);

    return {toggleWaveform};
};

